var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.validationMessage)?_c('span',{staticClass:"text-red-600"},[_vm._v(_vm._s(_vm.validationMessage))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }